import { create } from 'zustand';

import { requestAiAssistantClose } from '@modules/ai/stores/useAiAssistantStore';

export enum EItemScreenMode {
  CHANGES = 'CHANGES',
  COMMENTS = 'COMMENTS',
  MOCK_AI_FINDINGS = 'MOCK_AI_FINDINGS',
  PRE_CHANGE_IMPACT_ANALYSIS = 'PRE_CHANGE_IMPACT_ANALYSIS',
  POST_CHANGE_IMPACT_ANALYSIS = 'POST_CHANGE_IMPACT_ANALYSIS',
  IMPACT_ANALYSIS_SUMMARY = 'IMPACT_ANALYSIS_SUMMARY',
  AI = 'AI',
}

type TItemScreenStore = {
  screenMode?: EItemScreenMode;
  setScreenMode: (screenMode?: EItemScreenMode) => void;
  viewChanges: boolean;
  comparisonBaseVersionId?: string;
  setComparisonBaseVersionId: (id?: string) => void;
};

const useItemScreenStore = create<TItemScreenStore>((set, get) => ({
  screenMode: undefined,
  viewChanges: false,
  comparisonBaseVersionId: undefined,
  setScreenMode: (screenMode) => {
    const apply = () =>
      set({
        screenMode: screenMode,
        comparisonBaseVersionId: undefined,
        viewChanges:
          screenMode &&
          [
            EItemScreenMode.CHANGES,
            EItemScreenMode.POST_CHANGE_IMPACT_ANALYSIS,
            EItemScreenMode.IMPACT_ANALYSIS_SUMMARY,
          ].includes(screenMode),
      });
    // Leaving AI mode with a run still pending must confirm first, whichever button or dialog
    // makes the switch - the assistant store owns that ask and calls apply once it is settled.
    if (get().screenMode === EItemScreenMode.AI && screenMode !== EItemScreenMode.AI) {
      requestAiAssistantClose('sidebar', apply);
      return;
    }
    apply();
  },
  setComparisonBaseVersionId: (id) => set({ comparisonBaseVersionId: id }),
}));

export default useItemScreenStore;
